<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { TUILogin } from '@tencentcloud/tui-core';
export default {
  name: "App",
  created: function() {
    // var tim = util.initTim();
    
  },
  mounted: function() {
    // util.timLogin();
  },
  destroyed: function() {
    // util.timLogout();
  }
};
</script>

<style src="@/assets/css/common.css"/>